(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxWorkstationTasks(
    $filter, toastr, $timeout, Utils, $rootScope, $http
  ) {
    return {
      restrict: 'EA',
      scope: {
        workstation: '=workstation',
        tenant: '=tenant',
        me: '=me',
        isThisResourceMine: '=isThisResourceMine',
        meta: '=meta',
        returnWorkstation: '&returnWorkstation',
        printQueuesToBeChanged: '=printQueuesToBeChanged',
        storePrintQueuesToBeChanged: '&storePrintQueuesToBeChanged',
        callback: '&callback'
      },
      templateUrl: 'app/components/workstationProperties/workstationTasks/workstationTasks.template.html',
      link: function(scope) {

        scope.searchPattern = '';

        scope.currentDate = new Date();
        scope.thresholdToSwitchCreatedTimeFormat = 6;
        scope.searchInputFieldHolderFocusKey = "searchInputFieldHolderFocusKey";
        scope.orderTasksByText = "Type";
        scope.orderTasksByValue = "type";
        scope.reverseTasks = false;
        scope.hasExpiredTasks = false;
        scope.searchInputFieldHolderFocusKey = false;
        scope.deletingTasksInProgress = false;

        scope.taskList = scope.workstation.info._embedded.tasks ? angular.copy(scope.workstation.info._embedded.tasks) : [];

        (function(){
          checkForExpiredTasks();
        })();

        function checkForExpiredTasks() {
          var tasks = scope.workstation.info._embedded.tasks;
          if (tasks) {
            for (var i = 0; i < tasks.length; i++) {
              if (tasks[i].status === 'TIMED_OUT' || tasks[i].status === 'FAILED' || tasks[i].status === 'SUCCESS') {
                scope.hasExpiredTasks = true;
              }
            }
          }
        }

        scope.toggleShowSearchField = function($event) {
          if (scope.showSearchField) {
            scope.showSearchField = false;
          } else {
            scope.showSearchField = true;
          }
          $event.preventDefault();
          scope.searchInputFieldHolderFocusKey = true;
        };

        function isTaskPassingSearchPattern (task) {
          if (!scope.searchPattern) {
            return true;
          }
          if (task) {
            var fountByType = false;
            var fountByStatus = false;
            if (task.type) {
              fountByType = ($filter("translate")(task.type)).toLowerCase().indexOf(scope.searchPattern.toLowerCase()) !== -1;
            }
            if (task.status) {
              fountByStatus = ($filter("translate")(task.status)).toLowerCase().indexOf(scope.searchPattern.toLowerCase()) !== -1;
            }
            if (fountByType || fountByStatus) {
              return true;
            }
          }
          return false;
        };

        scope.updateSearchPattern = function () {
          scope.taskList = [];

          $timeout(function () {
            if (scope.workstation.info._embedded.tasks) {
              angular.forEach(scope.workstation.info._embedded.tasks, function (task) {
                if (isTaskPassingSearchPattern(task)) {
                  scope.taskList.push(task)
                }
              })
            }
          }, 500)

        }


        scope.changeOrderTaskByValue = function(value, textValue) {
          if (!angular.equals(scope.orderTasksByValue, value)) {
            scope.reverseTasks = false;
          } else {
            scope.reverseTasks = !scope.reverseTasks;
          }
          scope.orderTasksByValue = value;
          scope.orderTasksByText = textValue;
        };

        scope.clearExpiredTasks = function () {
          var expiredTasks = [];
          var tasks = scope.workstation.info._embedded.tasks;

          for (var i = 0; i < tasks.length; i++) {
            if (tasks[i].status === 'TIMED_OUT' || tasks[i].status === 'FAILED' || tasks[i].status === 'SUCCESS') {
              expiredTasks.push(tasks[i]);
            }
          }

          if (expiredTasks.length > 0) {
            removeQueueFromMemory(expiredTasks);
            timedExpiredTaskDelete(expiredTasks, 0)
          }
        }

        function removeQueueFromMemory (expiredTasks) {

          for (var i = 0; i < expiredTasks.length; i++) {
            for (var j = 0; j < scope.printQueuesToBeChanged.length; j++) {
              var printQueue = scope.printQueuesToBeChanged[j];
              if (printQueue && expiredTasks[i]._links['px:queue'] && expiredTasks[i]._links['px:queue'].href === scope.printQueuesToBeChanged[j].info._links.self.href) {
                scope.printQueuesToBeChanged.splice(j, 1);
                j--;
              }
            }
            scope.storePrintQueuesToBeChanged({printQueuesToBeChanged: scope.printQueuesToBeChanged})
          }

          angular.forEach(expiredTasks, function (task) {
            angular.forEach(scope.printQueuesToBeChanged, function (printQueue) {
              if (task._links['px:queue'].href === printQueue.info._links.self.href) {

              }
            })
          })
        }


        function timedExpiredTaskDelete (expiredTasks, counter) {
          scope.deletingTasksInProgress = true;
          $timeout(function () {
            deleteTask(expiredTasks[counter])
            counter = counter +1;
            if (counter <= expiredTasks.length -1) {
              timedExpiredTaskDelete(expiredTasks, counter)
            } else {
              toastr.success($filter("translate")("ExpiredTasksRemoved"));
              scope.deletingTasksInProgress = false;
              checkForExpiredTasks();
            }
          }, 100)
        }


        function deleteTask (expiredTasks) {
            var taskUrl = expiredTasks._links.self.href
            $http.delete(taskUrl).then(function(response){}).catch(function(error){});
        }


        var RELAY_WS_UPDATE_listener = $rootScope.$on('RELAY_WS_UPDATE', function (name, data)   {
          var workstationInScope = Utils.removeDomainFromUrl(scope.workstation.info._links.self.href);
          if (data.workstationInEvent === workstationInScope) {
            scope.workstation = data.workstation;
            scope.workstationOriginal = data.workstationOriginal;
            scope.taskList = scope.workstation.info._embedded.tasks ? angular.copy(scope.workstation.info._embedded.tasks) : [];
            if (!scope.deletingTasksInProgress) {
              checkForExpiredTasks();
            }
          }
        })

        scope.$on('$destroy', function() {
          RELAY_WS_UPDATE_listener();
        });


      }
    };
  }

  pxWorkstationTasks.$inject = ['$filter', 'toastr', '$timeout', 'Utils', '$rootScope', '$http'];

  angular
    .module('printix-admin')
    .directive('pxWorkstationTasks', pxWorkstationTasks);

})();
